import { useQuery, UseQueryResult } from "@tanstack/react-query";

import * as config from "@/config";

import { useHermesApiToken } from "./use-hermes-api-token";

export interface IssueSummary {
  group_id: string;
  students: {
    user_id: string;
    completed: number;
    on_track: number;
    overdue: number;
    total: number;
  }[];
}

/**
 * Hook to fetch the Issue Summary Insights data from Hermes.
 */
export function useIssueSummaryInsights(
  assessmentId: string,
  workId: string,
  studentIds: string[]
): UseQueryResult<IssueSummary[] | null> {
  const apiToken = useHermesApiToken({ assessmentId, workId });
  return useQuery(
    [`insights/issues`, studentIds],
    async () => {
      const hermesUrl = `${config.HERMESV2_ENDPOINT}/api/insights/issues`;
      try {
        const response = await fetch(hermesUrl, {
          method: "POST",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${apiToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_ids: studentIds,
            group_ids: [],
          }),
        });

        const data: IssueSummary[] = await response.json();
        return data;
      } catch (e) {
        console.error("failed to fetch Task Summary from Hermes", e);
        return null;
      }
    },
    {
      cacheTime: 100, // No cache, as the default is 5 minutes.
      // Refetch the data only on refresh: decrease database load.
      refetchInterval: false,
      useErrorBoundary: true,
      enabled: !!apiToken,
    }
  );
}
